var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('h2',{staticClass:"pt-5"},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("suffix")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }